import React from 'react';

interface ErrorPageProps {
  error?: string;
  statusCode?: number;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ 
  error = 'No se pudo cargar el formulario',
  statusCode = 404 
}) => {
  const getErrorMessage = () => {
    switch (statusCode) {
      case 404:
        return 'El formulario que buscas no existe o ha sido eliminado.';
      case 403:
        return 'No tienes permisos para acceder a este formulario.';
      case 500:
        return 'Error interno del servidor. Por favor, intenta más tarde.';
      default:
        return error;
    }
  };

  const getErrorTitle = () => {
    switch (statusCode) {
      case 404:
        return 'Formulario no encontrado';
      case 403:
        return 'Acceso denegado';
      case 500:
        return 'Error del servidor';
      default:
        return 'Error';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {/* Logo de Kutamma */}
        <div className="flex justify-center mb-6">
          <img 
            src="/favicon.png" 
            alt="Kutamma Logo" 
            className="h-12 w-auto"
          />
        </div>
        {/* Código de error */}
        <div className="text-6xl font-bold text-gray-300 mb-4">
          {statusCode}
        </div>

        {/* Título */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {getErrorTitle()}
        </h1>

        {/* Mensaje de error */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          {getErrorMessage()}
        </p>

        {/* Botones de acción */}
        <div className="space-y-3">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
          >
            Intentar de nuevo
          </button>
          
          <button
            onClick={() => window.history.back()}
            className="w-full bg-gray-200 text-gray-800 py-3 px-4 rounded-lg hover:bg-gray-300 transition-colors duration-200 font-medium"
          >
            Volver atrás
          </button>
        </div>

        {/* Información adicional */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Si el problema persiste, contacta al administrador del sistema.
          </p>
        </div>
      </div>
    </div>
  );
}; 